import { useEffect } from 'react'

import { showLoading } from 'services/util'

import themeCss from '../components/sass/theme.module.scss'

import { useMutation } from '@tanstack/react-query'
import { graphql } from '../api'
import { updateSolicitationReviewMutation } from '../graphql/Mutations'

export default function SolicitationReviewButton(props) {

  //for solicitation review mutation
  const {data: updateAuctionResponse, error, isPending, mutate: saveAuction } = useMutation({
    mutationFn: (input) => {
      return graphql({query: updateSolicitationReviewMutation, variables: input })
    },
  })

  const updateReview = async (value) => {
    const input = {
      auctionId: props?.auctionDetail.AuctionId,
      reviewStatus: value
    }
    saveAuction(input)
  }

  useEffect(() => {
    showLoading(isPending)
  }, [isPending])

  useEffect(() => {
    if (error) {
      console.log("Auction update error: ", error)
      console.log(error.errors[0].message) // errors from Appsync take this format, there may be other formats depending on where the operation fails
    }
    else if (updateAuctionResponse) {
      console.log(updateAuctionResponse)
      console.log('Auction updated: ', updateAuctionResponse?.data.updateSolicitationReview)
      props.refreshAdminAuctionQuery()
    }
  }, [updateAuctionResponse, error, props.refreshAdminAuctionQuery])

  return (
    <>
      { props?.auctionDetail.ReviewStatus === 'Approved'
        ? <button className={`${themeCss['button']} ${themeCss['StrokeRed']}`} onClick ={() => {updateReview('Removed')}}>Remove Solicitation Review</button>
        : <button className={`${themeCss['button']} ${themeCss['StrokeBlue']}`} onClick ={() => {updateReview('Approved')}}>Approve Solicitation Review</button>
      }
    </>
  )
}